import en from './en.json';
import vi from './vi.json';
import zh from './zh.json';
import ru from './ru.json';
import fr from './fr.json';

export default {
  en,
  vi,
  zh,
  ru,
  fr
}